import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 14, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 21 23' className={className} fill={fillColor}>
      <g>
        <g transform='translate(-32.000000, -182.000000)'>
          <g id='Group-13' transform='translate(33.000000, 183.000000)'>
            <g id='Stroke-2805'>
              <path d='M9.5,21.5C9.2,21.5,9,21.3,9,21v-2c0-0.3,0.2-0.5,0.5-0.5S10,18.7,10,19v2C10,21.3,9.8,21.5,9.5,21.5z' />
            </g>
            <g id='Stroke-2806'>
              <path d='M19,12h-2c-0.3,0-0.5-0.2-0.5-0.5S16.7,11,17,11h2c0.3,0,0.5,0.2,0.5,0.5S19.3,12,19,12z' />
            </g>
            <g id='Stroke-2807'>
              <path d='M9.5,4.5C9.2,4.5,9,4.3,9,4V0c0-0.3,0.2-0.5,0.5-0.5S10-0.3,10,0v4C10,4.3,9.8,4.5,9.5,4.5z' />
            </g>
            <g id='Stroke-2808'>
              <path d='M5.7,20.7c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.7L6,18.2c0.1-0.3,0.4-0.4,0.7-0.3C6.9,18,7,18.3,6.9,18.6 l-0.8,1.8C6.1,20.6,5.9,20.7,5.7,20.7z' />
            </g>
            <g id='Stroke-2809'>
              <path d='M13.3,20.7c-0.2,0-0.4-0.1-0.5-0.3l-0.8-1.8c-0.1-0.3,0-0.5,0.3-0.7c0.3-0.1,0.5,0,0.7,0.3l0.8,1.8 c0.1,0.3,0,0.5-0.3,0.7C13.5,20.7,13.4,20.7,13.3,20.7z' />
            </g>
            <g id='Stroke-2810'>
              <path d='M2,12H0c-0.3,0-0.5-0.2-0.5-0.5S-0.3,11,0,11h2c0.3,0,0.5,0.2,0.5,0.5S2.3,12,2,12z' />
            </g>
            <g id='Stroke-2811'>
              <path d='M16.4,9.1C16.2,9.1,16,9,16,8.8c-0.1-0.3,0-0.5,0.3-0.7l1.8-0.8c0.3-0.1,0.5,0,0.7,0.3c0.1,0.3,0,0.5-0.3,0.7l-1.8,0.8 C16.6,9.1,16.5,9.1,16.4,9.1z' />
            </g>
            <g id='Stroke-2812'>
              <path d='M0.7,15.6c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.3,0-0.5,0.3-0.7l1.8-0.8c0.3-0.1,0.5,0,0.7,0.3s0,0.5-0.3,0.7l-1.8,0.8 C0.9,15.6,0.8,15.6,0.7,15.6z' />
            </g>
            <g id='Stroke-2813'>
              <path d='M16.2,18.7c-0.1,0-0.3,0-0.4-0.1l-1.4-1.4c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l1.4,1.4c0.2,0.2,0.2,0.5,0,0.7 C16.5,18.7,16.3,18.7,16.2,18.7z' />
            </g>
            <g id='Stroke-2814'>
              <path d='M14.8,6.7c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l1.4-1.4c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-1.4,1.4 C15.1,6.6,14.9,6.7,14.8,6.7z' />
            </g>
            <g id='Stroke-2815'>
              <path d='M12.4,5.1c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.7l0.8-1.8c0.1-0.3,0.4-0.4,0.7-0.3c0.3,0.1,0.4,0.4,0.3,0.7 l-0.8,1.8C12.8,5,12.6,5.1,12.4,5.1z' />
            </g>
            <g id='Stroke-2816'>
              <path d='M6.6,5.1C6.4,5.1,6.2,5,6.2,4.8L5.4,2.9c-0.1-0.3,0-0.5,0.3-0.7c0.3-0.1,0.5,0,0.7,0.3l0.8,1.8c0.1,0.3,0,0.5-0.3,0.7 C6.8,5.1,6.7,5.1,6.6,5.1z' />
            </g>
            <g id='Stroke-2817'>
              <path d='M4.2,6.7c-0.1,0-0.3,0-0.4-0.1L2.4,5.1c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l1.4,1.4c0.2,0.2,0.2,0.5,0,0.7 C4.5,6.6,4.3,6.7,4.2,6.7z' />
            </g>
            <g id='Stroke-2818'>
              <path d='M2.8,18.7c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l1.4-1.4c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-1.4,1.4 C3,18.7,2.9,18.7,2.8,18.7z' />
            </g>
            <g id='Stroke-2819'>
              <path d='M18.3,15.6c-0.1,0-0.1,0-0.2,0l-1.8-0.8c-0.3-0.1-0.4-0.4-0.3-0.7c0.1-0.3,0.4-0.4,0.7-0.3l1.8,0.8 c0.3,0.1,0.4,0.4,0.3,0.7C18.7,15.5,18.5,15.6,18.3,15.6z' />
            </g>
            <g id='Stroke-2820'>
              <path d='M2.6,9.1c-0.1,0-0.1,0-0.2,0L0.5,8.3C0.3,8.2,0.2,7.9,0.3,7.7c0.1-0.3,0.4-0.4,0.7-0.3l1.8,0.8C3,8.3,3.1,8.6,3,8.8 C3,9,2.8,9.1,2.6,9.1z' />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
});

export default React.memo(Icon);
